export enum SearchBy {
  ID_NUMBER = "id_number",
  INFRINGEMENT_NUMBER = "infringement_number",
}

export enum FineType {
  WARRANT = "Warrant",
  NONWARRANT = "Fine",
}

export interface InfringementModel {
  statusDescription: string;
  messageId: string;
  transmissionDateTime: string;
  amount: number;
  offenceType: string;
  warrantOfArrestPending: boolean;
  noticeNumber: string;
  laCode: string;
  offenceLocation: string;
  registrationNumber: string;
  dueDate: string;
  offenceDate: string;
  idNumber: string;
  courtCode: string;
  courtName: string;
  courtDate: string;
  contemptOfCourtAmount: number;
  speed: string;
  zone: string;
  offenderName: string;
  summonsNumber: string;
  warrantNumber: number;
  caseNumber: number;
}

export interface FineModel {
  type: FineType | null;
  currentStep: number;
  infringement?: InfringementModel | null;
  account: string | null;
  infringementToken: string | null;
  searchBy: SearchBy | null;
  searchedID: string | null;
  idFines: IDFines[] | null;
}

export enum DisplayStatus {
  HIDE = "hide",
  GREYED = "grey-out",
  DISPLAY = "display",
}

export interface IDFines {
  amount: number;
  offenceType: string;
  noticeNumber: string;
  laCode: string;
  laDescription: string;
  registrationNumber: string;
  dueDate: string;
  offenceDate: string;
  warrantOfArrestPending: boolean;
  isPaid: boolean;
  displayStatus: DisplayStatus;
}

export interface HistoryModel {
  id: number;
  account_number: string;
  date_paid: string;
  transaction_id: string;
  amount_paid: string;
  warrant_status: FineType;
  id_number: string;
}

export interface Col {
  title: string;
  accessor: string;
}
